import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'

export default ConfirmationDialog
